module.exports = __webpack_public_path__ + "img/202627_a_en.cfff5aab.png";